import React, { Component, PropTypes } from 'react';
import { parseQueryString } from './../store/history.js';
import {
	closeStepsDepositflow,
	confDepositPaymentFromRegister,
	confDepositPaymentFromShop,
	confDepositPayment as conf
} from './../payment/common/lib/utils/router-config.js';
import navDeposit from './../payment/navdeposit/index.js';
import payment from './../payment/payment/index.js';

class DepositPayment extends Component {
	componentWillMount() {
		const { history: { push }, location } = this.props;
		const query = parseQueryString(location);
		const referrer = query && query.referrer ? query.referrer : null;
		closeStepsDepositflow({
			bonus: true,
			pendingwithdrawals: true,
			payment: false,
			depositResult: true
		});
		/* navDeposit sets routes and callbacks for navigation, skip, back, close */
		if (referrer === 'register') {
			navDeposit.init(confDepositPaymentFromRegister);
		} else if (referrer === 'shop') {
			payment.close(); // this navigation enters or re-enters the depositflow and elements have to removed to avoid duplication. This action is covered by '.close()'
			navDeposit.init(confDepositPaymentFromShop);
		} else {
			navDeposit.init(conf);
		}
		payment.init({
			wrapElmSelector: '#js-deposit-action',
			textkeys: conf.textkeys.selector,
			ageverifycb() {
				payment.close();
				navDeposit.close();
				push('/account/upload/age-verify');
			},
			agedontverifycb() {
				payment.close();
				navDeposit.close();
				push('/account');
			}
		});
	}

	render() {
		return (<div id="deposit-payment" />);
	}
}
// TODO: disabling linter: the propTypes currently are not used according to full purpose and
// may later be filled correctly.
/* eslint-disable*/
DepositPayment.propTypes = {
	history: PropTypes.object,
	location: PropTypes.object
};
/* eslint-enable */
export default DepositPayment;



// WEBPACK FOOTER //
// ./mobile-core/src/components/deposit-payment.js